// The top bar shown instead of the sidebar below md (MobileNav). It is not sticky,
// so full-height screens subtract it from the viewport.
export const MOBILE_NAV_HEIGHT = '80px';

export const heightBelowMobileNav = (extra?: string): string =>
	extra
		? `calc(100dvh - ${MOBILE_NAV_HEIGHT} - ${extra})`
		: `calc(100dvh - ${MOBILE_NAV_HEIGHT})`;
